var exports = {
  "D": "x31de4314--9a51de--title",
  "n": "x31de4314--9a51de--link",
};

module.exports = exports;
